import React from 'react';
import { ModernHeader } from '../components/ModernHeader';
import { Footer } from '../components/Footer';
import { MapPin, Phone, Mail } from 'lucide-react';
export function AboutPage() {
  const expertiseAreas = ['Mounted units including Pillow Blocks and Flanged Bearings', 'Roller Chain both Steel and Stainless Steel', 'Sprockets', 'Pulleys', 'Shaft Collars', 'Electric Motors', 'Gear Reducers'];
  return <div className="min-h-screen bg-gray-50" data-id="element-516">
      <ModernHeader data-id="element-517" />

      {/* Page Header Banner */}
      <section className="bg-gray-800 py-12" data-id="element-518">
        <div className="max-w-7xl mx-auto px-4" data-id="element-519">
          <h1 className="text-3xl md:text-4xl font-bold text-white text-center" data-id="element-520">
            About Us
          </h1>
        </div>
      </section>

      {/* Main Content */}
      <main className="py-12 md:py-16" data-id="element-521">
        <div className="max-w-4xl mx-auto px-4" data-id="element-522">
          {/* Intro Card */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 md:p-10 mb-8" data-id="element-523">
            <p className="text-lg text-gray-700 leading-relaxed mb-8" data-id="element-524">
              <strong className="text-gray-900" data-id="element-525">USA Bearings & Belts</strong>{' '}
              home office is located in Largo, FL, with distribution locations
              throughout the US, offering{' '}
              <span className="underline" data-id="element-526">Industrial Supplies</span>,
              Agricultural and Recreational products to buyers{' '}
              <strong className="underline" data-id="element-527">around the world.</strong>
            </p>

            {/* Expertise Section */}
            <div className="text-center mb-8" data-id="element-528">
              <p className="text-lg text-gray-700 mb-6" data-id="element-529">
                With many years of experience in motion distribution with
                expertise in:
              </p>

              <ul className="space-y-2 mb-6" data-id="element-530">
                {expertiseAreas.map(area => <li key={area} className="text-lg text-gray-700" data-id="element-531">
                    {area}
                  </li>)}
              </ul>

              <p className="text-xl font-semibold text-gray-900 mt-6" data-id="element-532">
                We can supply you with "Great Bearings"
              </p>
            </div>

            {/* Customer Service Section */}
            <div className="border-t border-gray-200 pt-8 mt-8" data-id="element-533">
              <p className="text-lg text-gray-700 leading-relaxed mb-6" data-id="element-534">
                We are proud to share our product knowledge and commitment to{' '}
                <strong className="underline" data-id="element-535">Customer Service</strong>. Our
                affiliations provide us access to a broad range of many motion
                component manufacturers and product lines. If you're an{' '}
                <strong className="underline" data-id="element-536">OEM</strong> we offer{' '}
                <strong className="underline" data-id="element-537">quantity discounts</strong> and
                can assist you with many of your engineered/custom products.
              </p>

              <p className="text-lg text-gray-700 leading-relaxed mb-6" data-id="element-538">
                You may <strong className="underline" data-id="element-539">call or email</strong> us
                your requirement for our assistance with your need and you will
                receive our prompt attention.
              </p>

              <p className="text-lg text-gray-700 leading-relaxed" data-id="element-540">
                We look forward to working for <strong data-id="element-541">you!</strong>
              </p>
            </div>
          </div>

          {/* Image Section */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 md:p-8" data-id="element-542">
            <div className="flex flex-col items-center" data-id="element-543">
              <img src="https://drwzpk38qkpfb.cloudfront.net/www.usabearingsandbelts.com/uploaded/images/08.17.10%20-%20USA%20Bearings%20&%20Belts%20004.jpg" alt="Chamber of Commerce Ribbon Cutting Ceremony" className="max-w-full h-auto rounded-lg shadow-md mb-4" style={{
              maxWidth: '400px'
            }} data-id="element-544" />
              <p className="text-gray-600 text-center italic" data-id="element-545">
                Chamber of Commerce Ribbon Cutting Ceremony
              </p>
            </div>
          </div>

          {/* Contact CTA */}
          <div className="bg-gray-800 rounded-xl p-6 md:p-8 mt-8 text-center" data-id="element-546">
            <h2 className="text-2xl font-bold text-white mb-4" data-id="element-547">
              Ready to Get Started?
            </h2>
            <p className="text-gray-300 mb-6" data-id="element-548">
              Contact our knowledgeable team for assistance with your
              requirements.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-549">
              <a href="tel:863-337-4984" className="inline-flex items-center gap-2 bg-red-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-red-700 transition-colors" data-id="element-550">
                <Phone className="w-5 h-5" data-id="element-551" />
                863-337-4984
              </a>
              <a href="mailto:sales@usabearingsandbelts.com" className="inline-flex items-center gap-2 bg-white/10 text-white px-6 py-3 rounded-lg font-medium hover:bg-white/20 transition-colors border border-white/20" data-id="element-552">
                <Mail className="w-5 h-5" data-id="element-553" />
                Email Us
              </a>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-554" />
    </div>;
}